<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16"
        style="enable-background:new 0 0 16 16;" xml:space="preserve" aria-hidden="true">
        <g id="Flood_icon">
            <g>
                <path class="st1" d="M8.3,3.8C7,3.8,5.8,3.1,4.8,2.1c-1.3,1.5-3.3,1.7-4,1.7C0.4,3.7,0,3.4,0,2.9s0.4-0.8,0.8-0.8
			c1,0,2.4-0.4,3-1.4C4,0.4,4.4,0.2,4.7,0.1c0.4,0,0.7,0.2,1,0.5c0.7,1,1.7,1.6,2.6,1.6c0.9,0,1.7-0.5,2.3-1.5
			c0.2-0.3,0.6-0.5,0.9-0.5c0.4,0,0.7,0.2,0.9,0.5c0.8,1.2,2.4,1.5,2.7,1.5c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8
			c-0.6,0-2.4-0.3-3.6-1.7C10.7,3.1,9.5,3.7,8.3,3.8C8.3,3.8,8.3,3.8,8.3,3.8z" />
                <path class="st1" d="M8.3,9.8C7,9.8,5.8,9.2,4.8,8.1c-1.3,1.5-3.3,1.7-4,1.7C0.4,9.8,0,9.4,0,9c0-0.4,0.4-0.8,0.8-0.8
			c1,0,2.4-0.4,3-1.4C4,6.4,4.4,6.2,4.7,6.2c0.4,0,0.7,0.2,1,0.5c0.7,1,1.7,1.6,2.6,1.6c0,0,0,0,0,0c0.9,0,1.7-0.5,2.3-1.5
			c0.2-0.3,0.6-0.5,0.9-0.5c0,0,0,0,0,0c0.4,0,0.7,0.2,0.9,0.5c0.8,1.2,2.4,1.4,2.7,1.4C15.7,8.2,16,8.5,16,9c0,0.4-0.4,0.8-0.8,0.8
			c-0.6,0-2.4-0.3-3.6-1.7C10.7,9.2,9.5,9.8,8.3,9.8C8.3,9.8,8.3,9.8,8.3,9.8z" />
                <path class="st1" d="M8.3,15.9c-1.2,0-2.5-0.6-3.4-1.7c-1.3,1.5-3.3,1.7-4,1.7c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8
			c1,0,2.4-0.4,3-1.4c0.2-0.3,0.5-0.5,0.9-0.6c0.4,0,0.7,0.2,1,0.5c0.7,1,1.7,1.6,2.6,1.6c0,0,0,0,0,0c0.9,0,1.7-0.5,2.3-1.5
			c0.2-0.3,0.6-0.5,0.9-0.5c0,0,0,0,0,0c0.4,0,0.7,0.2,0.9,0.5c0.8,1.2,2.4,1.4,2.7,1.4c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8
			c-0.6,0-2.4-0.3-3.6-1.7C10.7,15.3,9.5,15.9,8.3,15.9C8.3,15.9,8.3,15.9,8.3,15.9z" />
            </g>
        </g>
    </svg>
</template>

<style scoped>
path {
    fill: white;
}
</style>
